import React, { useState, useEffect } from 'react';
import Comm from '../comm/comm';
import { toast } from 'react-toastify';
import Tools from '../tools/tools';
import { Dialog } from 'primereact/dialog';
import moment from 'moment';


const ModalRequestPath = ({ display, requestId, closeFunc }) => {

    let [data, setData] = useState();

    useEffect(() => {
        if (requestId) {
            Comm.Instance().get(`requestpath?requestId=${requestId}`)
                .then(result => {
                    setData(result.data);
                }).catch(error => Tools.ProcessError(error));
        }
    }, [requestId]);

    if (!data) {
        return null;
    }

    return (
        <Dialog header="История на преписката" visible={display} style={{ width: '50vw' }} footer="" onHide={() => closeFunc(null)}>
            <div className="container">
                <h2>{data.Name}</h2>
                <p><strong>Разпределено на</strong>: {data.GivenTo}</p>
                <p><strong>Дата</strong>: {moment(data.CreatedOn).format("DD.MM.YYYY")}</p>
                <p><strong>Име на обект</strong>: {data.ObjectName}</p>
                <p><strong>Номер на обект</strong>: {data.ObjectNumber}</p>
                <p><strong>Вх. номер</strong>: {data.NumId}</p>
                <p><strong>Статус</strong>: {data.RequestState}</p>
                <p><strong>Тип</strong>: {data.RequestType}</p>
                {
                    data.Jobs && data.Jobs.map((i, ix) => <div style={{ 'border': '1px solid black' }}>
                        <h2>{i.Name}</h2>
                        <p><strong>Дата</strong>: {moment(i.CreatedOn).format("DD.MM.YYYY")}</p>
                        <p><strong>Статус</strong>: {i.JobState}</p>
                        <p><strong>Тип</strong>: {i.JobType}</p>
                        <p><strong>Разпределено на</strong>: <ul>{i.Users.map(u => <li>{u}</li>)}</ul></p>


                    </div>)
                }
            </div>


        </Dialog>

    );
}


export default ModalRequestPath;

